import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var genFormValidateMotionStyle = function genFormValidateMotionStyle(token) {
  var componentCls = token.componentCls;
  var helpCls = "".concat(componentCls, "-show-help");
  var helpItemCls = "".concat(componentCls, "-show-help-item");
  return _defineProperty({}, helpCls, _defineProperty({
    // Explain holder
    transition: "opacity ".concat(token.motionDurationFast, " ").concat(token.motionEaseInOut),
    '&-appear, &-enter': {
      opacity: 0,
      '&-active': {
        opacity: 1
      }
    },
    '&-leave': {
      opacity: 1,
      '&-active': {
        opacity: 0
      }
    }
  }, helpItemCls, _defineProperty(_defineProperty({
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationFast, " ").concat(token.motionEaseInOut, ",\n                     opacity ").concat(token.motionDurationFast, " ").concat(token.motionEaseInOut, ",\n                     transform ").concat(token.motionDurationFast, " ").concat(token.motionEaseInOut, " !important")
  }, "&".concat(helpItemCls, "-appear, &").concat(helpItemCls, "-enter"), {
    transform: "translateY(-5px)",
    opacity: 0,
    '&-active': {
      transform: 'translateY(0)',
      opacity: 1
    }
  }), "&".concat(helpItemCls, "-leave-active"), {
    transform: "translateY(-5px)"
  })));
};
export default genFormValidateMotionStyle;